module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/title_vanue-3c5a7eeb7d245fc1e5b4d0f262530370.svg";